import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCurrentLineEnvironments = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine.environments,
  (environments) => environments,
);
